import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=4cccb068&scoped=true&"
import script from "./Branch.vue?vue&type=script&lang=js&"
export * from "./Branch.vue?vue&type=script&lang=js&"
import style0 from "./Branch.vue?vue&type=style&index=0&id=4cccb068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cccb068",
  null
  
)

export default component.exports